import get from "lodash/get";
import { ZIPREG } from "../constants";

const Billing = (app) => {
  app
    // Update credit card info
    .post(
      "/billing/update/source",
      async ({ req, res, api, flash, assert, fail }) => {
        const { body } = req;

        assert(
          process.browser,
          400,
          "Unable to process credit card change in current browser."
        );
        assert(
          body.source,
          400,
          "Please fill out the form to update your billing information."
        );

        // Validations
        if (get(body, "source.address_zip", false)) {
          const zipPattern = ZIPREG[body.source.address_country];
          if (zipPattern)
            assert(
              zipPattern.test(body.source.address_zip),
              400,
              "Invalid zip/postal code"
            );
        }

        if (get(body, "source.address_line1", false)) {
          assert(body.source.address_city, 400, "A city is required.");
          assert(
            body.source.address_zip,
            400,
            "A zip/postal code is required."
          );
          assert(body.source.address_country, 400, "A country is required.");
        }

        const addressInfo = {
          addressLine1: body.source.address_line1,
          addressLine2: body.source.address_line2,
          addressCity: body.source.address_city,
          addressState: body.source.address_state,
          addressZip: body.source.address_zip,
          addressCountry: body.source.address_country,
        };

        if (body.stripeToken) {
          body.source = body.stripeToken.token;
        }

        Object.assign(body.source, addressInfo);
        // If no new card is provided, perform the same action as updating just the address
        if (!body.stripeToken) {
          await api(`user-update-billing-address`, { method: "PUT", body });
        } else {
          await api(`user-update-billing-info`, { method: "PUT", body });
        }
        flash(
          "success",
          "Your credit card information has been successfully updated."
        );
        res.redirect("/dashboard/settings/billing?closeEditCredit=true");
      }
    )
    // Update coach credit card info
    .post(
      "/coach-billing/update/source",
      async ({ req, res, api, flash, assert, fail, momentTZ }) => {
        const { body } = req;

        assert(
          process.browser,
          400,
          "Unable to process credit card change in current browser."
        );
        assert(
          body.source,
          400,
          "Please fill out the form to update your billing information."
        );

        // Validations
        if (get(body, "source.address_zip", false)) {
          const zipPattern = ZIPREG[body.source.address_country];
          if (zipPattern)
            assert(
              zipPattern.test(body.source.address_zip),
              400,
              "Invalid zip/postal code"
            );
        }

        if (get(body, "source.address_line1", false)) {
          assert(body.source.address_city, 400, "A city is required.");
          assert(
            body.source.address_zip,
            400,
            "A zip/postal code is required."
          );
          assert(body.source.address_country, 400, "A country is required.");
        }

        if (body.stripeToken) {
          body.source = body.stripeToken.token;
        }

        // If no new card is provided, perform the same action as updating just the address
        if (!body.stripeToken) {
          await api(`coach-update-billing-address`, { method: "PUT", body });
        } else {
          await api(`coach-update-billing-info`, { method: "PUT", body });
        }
        flash(
          "success",
          "Your credit card information has been successfully updated."
        );
        res.redirect(
          "/coaching-portal/settings/coach-manage-billing?closeEditCredit=true"
        );
      }
    )
    .post(
      "/billing/coach",
      async ({ req, locals, res, load, api, flash, assert, fail }) => {
        const { body } = req;

        // call the api to attach the source to the stripe user
        try {
          await (
            await api(`stripe-attach-source?user=${locals.activeUser._id}`, {
              method: "PUT",
              body: body,
            })
          ).json();

          // flash success update to the user
          flash("success", "Your account has been successfully activated!");

          res.redirect("/coaching-portal");
        } catch (e) {
          console.log("error", e);
          flash("error", e.message);
          res.refreshWith({}, { url: "back" });
        }
      }
    );
};

export default Billing;
